export default {
  fillInOrder: 'Preencher pedido de compra',
  inputTips: "（<span style='color: red'>*</span> é obrigatório）",
  process: {
    first: 'Preencher pedido e enviar',
    second: 'Pagar custo do produto e frete doméstico',
    three: 'Aguardar produto chegar ao armazém',
  },
  productInfo: 'Informações do produto',
  productInfoTips:
    'Todos os produtos de compra exibidos no acbuy vêm de plataformas de compras terceirizadas, não são vendidos diretamente pelo acbuy. Portanto, se os produtos acima envolverem qualquer problema de violação, toda a responsabilidade gerada será assumida pelo vendedor correspondente na plataforma terceirizada, o acbuy não assume qualquer responsabilidade relacionada, incidental ou conexa.',
  fees: 'Taxas',
  feeStandard: 'Padrão de taxas',
  feeStandardTips:
    'Para pedidos de compra enviados nesta página, se os produtos vierem de plataformas terceirizadas como Kongfuzi livros usados, Xiaohongshu, Youzan, etc., pode haver situações em que não é possível comprar. Os produtos podem ter riscos de transporte ou podem cobrar taxas de serviço adicionais. A taxa de serviço real precisa ser verificada pelo agente. Para mais detalhes, consulte "Centro de Ajuda - Padrão de Taxas de Serviço de Compra Terceirizada".',
  link: 'Link',
  name: 'Nome',
  remark: 'Observações',
  unitPrice: 'Preço unitário (RMB)',
  qty: 'Quantidade',
  goodsAttr: 'Especificações ou material',
  chinaPostage: 'Frete (RMB)',
  holder: {
    inputUrl: 'Por favor, cole a URL do produto',
    inputName: 'Por favor, insira o nome do produto aqui (dentro de 100 caracteres)',
    inputAttr: 'Por favor, insira as especificações do produto',
    inputRemark:
      'Se o produto tiver vários estilos, tamanhos, cores, etc., por favor, especifique o que você precisa aqui de acordo com a descrição de categoria da página do produto. Se você comprar o mesmo produto mas com especificações diferentes, por favor, faça pedidos separados.',
    contactName: 'Por favor, insira informações de contato',
    contactEmail: 'Por favor, insira e-mail de contato',
    contactPhone: 'Por favor, insira telefone de contato',
  },
  other: 'Outros (opcional)',
  productImg: 'Imagem do produto',
  fareTip:
    'Frete doméstico para o endereço do armazém (se não tiver certeza, pode preencher 0, o comprador verificará para você e iniciará pagamento adicional)',
  customizedLogisticsForm: 'Formulário de solicitação de logística personalizada',
  submitInfo: 'Enviar informações do produto',
  customizedProcess: {
    first: 'Preencher pedido e enviar',
    second: 'Enviar informações do produto',
    three: 'Aguardar acbuy entrar em contato com você',
  },
  deliveryAddress: 'Endereço de envio',
  contactDetail: 'Detalhes de contato',
  contactName: 'Nome de contato',
  contactPhone: 'Telefone de contato',
  contactEmail: 'E-mail de contato',
  customizedLogisticsInformation: 'Informações de logística personalizada',
  fromWarehouse: 'Do armazém',
  manuallyFill: 'Preencher informações do produto manualmente',
  contactInfoTips1:
    '· Para melhor serviço, por favor, preencha o formulário com detalhes verdadeiros. Dentro de três dias úteis após o envio da solicitação, pessoal especializado entrará em contato com você. ',
  contactInfoTips2:
    '· Para pacotes abaixo de 30KG, recomenda-se que os clientes escolham entrega de logística online.',
  contactInfoTips3:
    '· O serviço personalizado envolve apenas transporte logístico, as mercadorias apenas passam por verificação de aparência, não fornece inspeção detalhada de qualidade das mercadorias.',
  myWarehouse: 'Meu armazém',
  itemName: 'Nome do produto',
  volume1: 'Informações de volume após empacotamento do produto',
  volume: 'Volume(cm)',
  weight: 'Peso',
  length: 'Comprimento',
  width: 'Largura',
  height: 'Altura',
  warehouseItem: 'Produto do armazém',
  manuallyItem: 'Produto manual',
  submitSuccess: 'Solicitação de logística personalizada enviada com sucesso',
  submitMsg:
    'Entraremos em contato com você o mais rápido possível, por favor, aguarde com paciência.',
  inputProductMsg: 'Por favor, insira informações do produto',
  selectZone: 'Por favor, selecione o código de área do telefone de contato',
  productName: 'Link ou nome do produto',
}
